import HighContrast from './high-contrast';

export default (di) => {
	di
		.setType({type: HighContrast, name: 'HighContrast', mixins: ['domMixin']})
		.set('accessibility/highContrast', di.lazyNew('HighContrast'))
	;
};
